var exports = {
  "o": "ForumPostActions.module__actions___T0twcE",
};

module.exports = exports;
